import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, isPublicPath } from "@/lib/analytics";

/**
 * Fires a GA4 `page_view` on every SPA navigation — but ONLY for
 * public marketing / auth / legal routes. Anything under `/app/*` is
 * deliberately skipped so authenticated parent traffic (and any
 * child / household identifiers that might show up in titles or
 * paths) never reaches Google.
 *
 * No DOM output. Mount once at app-root level.
 */
export default function PublicAnalytics() {
  const location = useLocation();
  useEffect(() => {
    if (!isPublicPath(location.pathname)) return;
    trackPageView(location.pathname + location.search, document.title);
  }, [location.pathname, location.search]);
  return null;
}
